import { Injectable } from '@angular/core';
import { PaymentDiscount } from '../entities/payment-discount';
import { BaseTableService } from './base-table.service';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '@mobileia/authentication';
import { Observable } from 'rxjs';
import { ApiResponse, ApiPagination, MIATableModel } from '@mobileia/core';
import { Category } from '../entities/category';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentDiscountService extends BaseTableService<PaymentDiscount> {

  constructor(
    protected http: HttpClient,
    protected authService: AuthenticationService
  ) {
    super(http, authService);
    this.basePathUrl = 'admin/payment-discount';
  }
  
}
